import React, { useRef, useState } from "react";
import { Tab } from "@headlessui/react";

import IntroduceOverview from "../IntroduceOverview";
import GridListWithImage from "../GridListwithImage";
import Timeline from "../Timeline";
import CompanyExample from "../CompanyExample";

function classNames(...classes: any) {
    return classes.filter(Boolean).join(" ");
}

const TabBasic = () => {
    const [categories] = useState({
        Overview: [
            {
                id: 1,
                content: (
                    <>
                        <IntroduceOverview /> <CompanyExample />
                        {/* <Features
                            cards={[
                                {
                                    imageSrc: "/img/introduce-01.png",
                                    subtitle: "ICT Convergence Technology",
                                    title: " ICT융합기술 사업화",
                                    description:
                                        "케이유융합소프트웨어연구센터는 ICT융합기술을 지속적으로 연구해왔으며, 현재 ICT융합 기술사업화 및 서비스 인큐베이팅을 통해 4차산업혁명을 선도하고자 합니다.",
                                    url: "#"
                                },
                                {
                                    imageSrc:
                                        "/img/salesforce_partner_badge.png",
                                    subtitle: "Salesforce",
                                    title: "Salesforce Partnership X Digital Transformation",
                                    description:
                                        "KUSRC는 공식 Salesforce Partner로서 Salesforce 도입을 통해서 고객 업무를 혁신하고 궁극적으로 더 많은 가치를 창출할 수 있도록 도와 드립니다.",
                                    url: "/dt"
                                }
                            ]}
                        />
                        <div className="grid grid-cols-2 gap-8 grayscale md:grid-cols-4  lg:grid-cols-5">
                            {ImgSrc.map((img, i) => (
                                <div
                                    key={i}
                                    className=" flex items-center  justify-center "
                                >
                                    <img src={img.imgURL} />
                                </div>
                            ))}
                        </div> */}
                    </>
                )
            }
        ],
        "Why KUSRC?": [
            {
                id: 1,
                content: (
                    <>
                        {" "}
                        <GridListWithImage
                            title={[<>Why KUSRC?</>]}
                            features01={[
                                {
                                    title: "다양한 데이터 경험",
                                    list01: "B2B, B2C 고객, 제품 등 데이터 통합을 통한 Single View 제공",
                                    list02: "데이터 통합 컨설팅부터 구축 및 운영 서비스까지 다양한 영역 서비스",
                                    list03: "신영와코루, K2KOREA, 골프존카운티, LG전자 등 다양한 산업의 데이터 통합 경험 보유",
                                    imgUrl: "/img/salesforce/why-img-01.png"
                                }
                            ]}
                            features02={[
                                {
                                    title: "다양한 AI Capability 보유",
                                    list01: "150건 이상의 AI 관련 특허/기술 이전 경험",
                                    list02: "Generative AI 관련 SCI 논문 실적 보유",
                                    list03: "전체 인력 중 50% 이상이 석사 학위 보유",
                                    list04: "관련 Capability 보유 (논문, 특허 등)",
                                    list05: "다양한 정부 R&D 과제 / 사업 수행",
                                    imgUrl: "/img/salesforce/why-img-05.png"
                                }
                            ]}
                            features03={[
                                {
                                    title: "Salesforce w/Agentforce",
                                    list01: "Salesforce 공식 Consulting 파트너사",
                                    list02: "Salesforce Agentforce 공식 Partner (최초)",
                                    list03: "Heroku, Sales, Service, Admin 등 Salesforce Certified 인력 보유",
                                    list04: "Salesforce RANGER 다수 보유",
                                    list05: "구축 CSAT(고객만족도) 97%",
                                    imgUrl: "/img/salesforce/why-img-03.png",
                                    badge: "공식파트너사"
                                }
                            ]}
                            features04={[
                                {
                                    title: "Databricks W/AI/BI, ML, GenAI",
                                    list01: "Databricks 공식 파트너사",
                                    list02: "AWS·Azure·GCP 전 클라우드 환경 대응",
                                    list03: "Lakehouse·Unity Catalog 기반 데이터 거버넌스 체계 수립",
                                    list04: "Salesforce Data 360–Databricks 데이터 연계 설계·구축",
                                    imgUrl: "/img/databricks/databricks_icon.svg",
                                    badge: "공식파트너사"
                                }
                            ]}
                            features05={[
                                {
                                    title: "Global Vendor Partnership",
                                    list01: "Snowflake",
                                    list02: "Integrate.io",
                                    list03: "Dreamfactory",
                                    imgUrl: "/img/salesforce/why-img-02.png",
                                    badge01: "/img/logo/badge_sf.svg",
                                    badge02: "/img/logo/badge_inter.svg",
                                    badge03: "/img/logo/badge_dream.svg"
                                }
                            ]}
                            // features={[
                            //     {
                            //         title: "",
                            //         description:
                            //             "전 임직원 Salesforce \n certifications 보유",
                            //         imgUrl: "https://cdn-icons-png.flaticon.com/512/4341/4341139.png"
                            //     },
                            //     {
                            //         title: "",
                            //         description:
                            //             "Saelsforece Sales/Service Cloud 구축, 연동 웹/모바일 시스템 구축",
                            //         imgUrl: "https://cdn-icons-png.flaticon.com/512/4341/4341139.png"
                            //     },
                            //     {
                            //         title: "",
                            //         description:
                            //             "Saelsforece CRM을 통해 체계적인 고객관리시스템, 실시간 고객과의 소통, 데이터 기반 전략 수립 및 실행이 가능한 환경을 제공",
                            //         imgUrl: "https://cdn-icons-png.flaticon.com/512/4341/4341139.png"
                            //     },
                            //     {
                            //         title: "",
                            //         description:
                            //             "Saelsforece CRM에 반영 가능한 제반기술(특허) 다수 보유",
                            //         imgUrl: "https://cdn-icons-png.flaticon.com/512/4341/4341139.png"
                            //     }
                            // ]}
                        />
                    </>
                )
            }
        ],
        History: [
            {
                id: 1,
                content: (
                    <>
                        <Timeline />
                    </>
                )
            }
        ]
    });

    const sectionRef = useRef<HTMLDivElement>(null);

    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({
            block: "start",
            behavior: "instant" as ScrollBehavior
        });
    };

    return (
        <div
            id="tab"
            ref={sectionRef}
            className="relative mx-auto w-full scroll-mt-below-header md:scroll-mt-below-header-md"
        >
            <Tab.Group onChange={scrollToSection}>
                <Tab.List className="sticky top-below-header z-30 border-b bg-white md:top-below-header-md">
                    <div className="mx-auto flex w-11/12 space-x-1 rounded-xl md:w-full md:max-w-md">
                        {Object.keys(categories).map(category => (
                            <Tab
                                key={category}
                                className={({ selected }) =>
                                    classNames(
                                        "md:text-md w-full py-4 text-base font-medium leading-5 focus:outline-none md:text-lg",

                                        selected
                                            ? "border-b-2 border-brand-light bg-white font-extrabold text-brand-light"
                                            : "text-gray-700 hover:bg-white/[0.42]  hover:text-brand"
                                    )
                                }
                            >
                                {category}
                            </Tab>
                        ))}
                    </div>
                </Tab.List>
                <Tab.Panels className="">
                    {Object.values(categories).map((posts, idx) => (
                        <Tab.Panel
                            key={idx}
                            className={classNames("focus:outline-none")}
                        >
                            <>
                                {posts.map(post => (
                                    <div key={post.id} className="relative ">
                                        {post.content}
                                    </div>
                                ))}
                            </>
                        </Tab.Panel>
                    ))}
                </Tab.Panels>
            </Tab.Group>
        </div>
    );
};
export default TabBasic;
